import MapRoute from "../../../../common/components/map/types/map-route";
import GpsCargoOrderRecord from "../../../../common/services/gps/cargo-order-records/gps-cargo-order-records";
import {
  SearchRoadRoutingResponseRoute,
  SearchRoadRoutingResponseRouteGeometryCoordinate,
} from "../../../../common/utils/search-road-route/search-road-routing.response";

const createCompletedMapRouteWaypoints = (
  responseItems: GpsCargoOrderRecord[],
): MapRoute["waypoints"] => {
  const sortedResponseItems = responseItems.sort(
    (itemA, itemB) =>
      new Date(itemA.recordTime).getTime() -
      new Date(itemB.recordTime).getTime(),
  );

  const waypoints: MapRoute["waypoints"] = sortedResponseItems.map((item) => ({
    latitude: item.lat,
    longitude: item.lon,
  }));

  return waypoints;
};

const createCompletedMapRoute = (
  responseItems: GpsCargoOrderRecord[],
): MapRoute => {
  const waypoints = createCompletedMapRouteWaypoints(responseItems);

  const mapRoute: MapRoute = {
    waypoints,
    options: {
      color: "#3699ff",
    },
  };

  return mapRoute;
};

const createPlannedMapRouteWaypoints = (
  routesResponseGeometryCoordinates: SearchRoadRoutingResponseRouteGeometryCoordinate[],
): MapRoute["waypoints"] => {
  return routesResponseGeometryCoordinates.map((coordinate) => {
    return {
      latitude: coordinate[1],
      longitude: coordinate[0],
    };
  });
};

const createPlannedMapRoute = (
  routesResponseGeometryCoordinates: SearchRoadRoutingResponseRouteGeometryCoordinate[],
): MapRoute => {
  const waypoints = createPlannedMapRouteWaypoints(
    routesResponseGeometryCoordinates,
  );

  return {
    waypoints,
  };
};

const createPlannedMapRoutes = (
  responseRoutes: SearchRoadRoutingResponseRoute[],
): MapRoute[] => {
  return responseRoutes.map((responseRoute) =>
    createPlannedMapRoute(responseRoute.geometry.coordinates),
  );
};

const orderDetailsMapRouteFactory = {
  createCompletedMapRoute,
  createPlannedMapRoutes,
  createPlannedMapRoute,
};

export default orderDetailsMapRouteFactory;
